/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Grid } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import MuiPhoneNumber from 'material-ui-phone-number';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';
import updateAnalytics from '../../actions/updateAnalytics';

export default function AlertDialog({ setLoading }) {
  const [open, setOpen] = React.useState(false);
  const [altVal, setAltVal] = React.useState('');

  const dispatch = useDispatch();
  const alternateNumber = useSelector(
    (state) => state.formState.Alternate_number
  );
  const restaurantId = useSelector((state) => state.formState.Restaurant_id);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    dispatch(updateState({ Signup_type: 'Promo' }));
    setOpen(false);
  };

  return (
    <>
      <Button
        onKeyDown={handleClickOpen}
        role="presentation"
        onClick={handleClickOpen}
      >
        <u>{translate('Enter Alternate Number')}</u>
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container>
          <Grid container item justify="flex-start">
            <IconButton
              variant="outlined"
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <DialogTitle id="alert-dialog-title">
          {translate('Enter Alternate Number')}{' '}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <MuiPhoneNumber
              fullWidth
              label="Owner Phone"
              defaultCountry="us"
              onChange={(value) => {
                setAltVal(value);
              }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={altVal.length !== 17}
            color="primary"
            autoFocus
            onClick={() => {
              dispatch(updateState({ Alternate_number: altVal }));
              updateAnalytics(
                {
                  alternateNumber: altVal,
                },
                restaurantId
              );
              handleClose();
            }}
          >
            {translate('Enter')}
          </Button>
        </DialogActions>
      </Dialog>{' '}
    </>
  );
}
